import { render, staticRenderFns } from "./admin-sms-settings.vue?vue&type=template&id=3262b232"
import script from "./admin-sms-settings.vue?vue&type=script&lang=js"
export * from "./admin-sms-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports